import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import VivahLogo from './VivahLogo';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="pourkas-nav-wrapper">
      {/* Tier 1: Top Direct Contact Bar */}
      <div className="nav-top-bar">
        <div className="nav-top-left">
          <span className="nav-top-pill">
            💍 Matrimony Consultant: <a href="tel:9857074103"><strong>Laxmikant Timilsina (9857074103)</strong></a>
          </span>
          <span style={{ opacity: 0.4 }}>|</span>
          <span className="nav-top-pill">
            🍽️ Catering Manager: <a href="tel:9867155395"><strong>Krishna Khanal (9867155395)</strong></a>
          </span>
        </div>

        <div className="nav-top-right">
          <span className="nav-top-pill">
            💻 Technical Support: <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer"><strong>Prakash Sharma Timilsina (pourkas.org)</strong></a>
          </span>
          <span style={{ opacity: 0.4 }}>|</span>
          <span className="nav-top-pill" style={{ fontSize: '0.74rem', opacity: 0.9, color: '#F7D070' }}>
            📍 Yogikuti, Butwal
          </span>
        </div>
      </div>

      {/* Tier 2: Main Brand & Navigation Bar */}
      <nav className="nav-main-bar">
        {/* Brand Logo & Title */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.7rem' }}>
          <VivahLogo size="small" />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontWeight: 900, fontSize: '1.35rem', color: '#7A1221', lineHeight: 1, fontFamily: 'var(--serif)' }}>
              Vivah Nepal
            </span>
            <span style={{ fontSize: '0.64rem', color: '#8C6A23', fontWeight: 800, letterSpacing: '0.04em' }}>
              Marriage Consultation Agency
            </span>
          </div>
        </Link>

        {/* Navigation Links */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.8rem' }}>
          <Link to="/consultation" style={{
            fontSize: '0.9rem',
            fontWeight: isActive('/consultation') ? 800 : 600,
            color: isActive('/consultation') ? '#9E1B32' : '#2d3748'
          }}>
            💍 Matrimony Registry
          </Link>

          <Link to="/catering" style={{
            fontSize: '0.9rem',
            fontWeight: isActive('/catering') ? 800 : 600,
            color: isActive('/catering') ? '#9E1B32' : '#2d3748'
          }}>
            🍽️ Sabitri Catering & Decor
          </Link>

          <Link to="/contact" style={{
            fontSize: '0.9rem',
            fontWeight: isActive('/contact') ? 800 : 600,
            color: isActive('/contact') ? '#9E1B32' : '#2d3748'
          }}>
            📍 Offices & Support
          </Link>
        </div>

        {/* Register Profile Action Button */}
        <div>
          <button className="btn btn-primary btn-sm" onClick={() => navigate('/consultation/register')}>
            Register Profile Now →
          </button>
        </div>
      </nav>
    </header>
  );
}
